import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const CertificateSinglenessModal = (props) => <RequestDetailModal {...props} />;

export default CertificateSinglenessModal;
